export const getSort = (state) => state.rankAdjustments.sort;

export const getFilter = (state) => state.rankAdjustments.filter;

export const getPaging = (state) => ({
  page: state.rankAdjustments.currentPage,
  itemsPerPage: state.rankAdjustments.itemsPerPage,
});
